<template>
  <div class="member-message" v-if="consults">
    <div class="">
      <div class="row justify-content-center mb-3">
        <div class="col-2 title text-start align-self-center">來源</div>
        <div class="col-2 title text-start align-self-center">編號</div>
        <div class="col-4 title text-start align-self-center">內容</div>
        <div class="col-4 col-md-2 title text-center align-self-center">狀態</div>
      </div>
      <template v-for="(consult, index) in consults">
        <div class="row pointer justify-content-center border-bottom border-gray pt-3 pb-3" v-if="consult.parentId === 0" :key="index" data-bs-toggle="modal" data-bs-target="#message-modal" @click="onItemSelected(consult.id)">
          <div class="col-2 text-start align-self-center">{{ getConsultType(consult.type) }}</div>
          <div class="col-2 text-start align-self-center">#{{ consult.id }}</div>
          <div class="col-4 text-start align-self-center text-truncate">{{ consult.textContent }}</div>
          <div class="col-4 col-md-2 text-center align-self-center">
            <span class="status-done-unread" v-if="hasUnread(consult.id)">已回覆</span>
            <span class="" v-else-if="isAllReplied(consult.id)">已回覆</span>
            <span class="status-ongoing" v-else>待處理</span>
          </div>
        </div>
      </template>
    </div>
    <message-modal :consult-group="consultGroup"/>
    <consultion-modal :consult="consultParent" @consult-submitted="apiGetConsults"/>
  </div>
</template>

<script>
import constant from '@/constant.js'
import userApi from '@/api/user.js'
import { mapGetters, mapMutations } from 'vuex'
import ConsultionModal from '@/components/ConsultionModal.vue'
import MessageModal from './MessageModal.vue'

export default {
  name: 'MemberMessage',
  components: {
    ConsultionModal,
    MessageModal
  },
  data: function () {
    return {
      selectedId: null
    }
  },
  computed: {
    ...mapGetters([
      'authId',
      'consults'
    ]),
    consultGroup: function () {
      var ret = null
      if (this.selectedId) {
        ret = this.getConsultGroup(this.selectedId)
      }
      return ret
    },
    consultParent: function () {
      var ret = null
      if (this.consults && this.selectedId) {
        var self = this
        ret = this.consults.find(e => e.id === self.selectedId)
      }
      return ret
    }
  },
  mounted: function () {
    this.apiGetConsults()
  },
  methods: {
    ...mapMutations([
      'signOut',
      'setConsults'
    ]),
    apiGetConsults: function () {
      var self = this
      userApi.getConsults(this.authId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.setConsults(rspData)
      })
    },
    apiSetConsultReaded: function (id) {
      var self = this
      userApi.setConsultReaded(id, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.apiGetConsults()
      })
    },
    getConsultType: function (type) {
      var ret = null
      switch (type) {
        case constant.CUSTOMER_SVC_TYPE.CONSULT:
          ret = '產品諮詢'
          break
        case constant.CUSTOMER_SVC_TYPE.CONTACT_US:
          ret = '聯絡表單'
          break
        default:
          break
      }
      return ret
    },
    hasUnread: function (id) {
      var ret = false
      if (this.consults) {
        var consultGroup = this.getConsultGroup(id)
        if (consultGroup) {
          ret = consultGroup.some(e => e.replyAdminId && !e.isReaded)
        }
      }
      return ret
    },
    isAllReplied: function (id) {
      var ret = false
      if (this.consults) {
        var consultGroup = this.getConsultGroup(id)
        if (consultGroup) {
          ret = consultGroup.every(e => e.replyAdminId)
        }
      }
      return ret
    },
    getConsultGroup: function (id) {
      var ret = null
      if (this.consults) {
        ret = this.consults.filter(e => e.id === id || e.parentId === id)
        ret.sort((a, b) => a.id - b.id) // sort by id asc
      }
      return ret
    },
    onItemSelected: function (id) {
      this.selectedId = id
      var consultGroup = this.getConsultGroup(id)
      if (consultGroup) {
        console.log(consultGroup)
        consultGroup.forEach(e => {
          if (e.replyAdminId && !e.isReaded) {
            this.apiSetConsultReaded(e.id)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 1.3rem;
  font-weight: 500;
}
.col.title {
  font-weight: 400;
}
.border-gray {
  border-color: #ededed;
}
.pointer {
  cursor: pointer;
}
.status-done-unread {
  color: var(--loft-color);
  border: 1px solid var(--loft-color);
  padding: 4px 8px;
}
.status-ongoing {
  color: var(--bs-dark);
  border: 1px solid var(--bs-dark);
  padding: 4px 8px;
}

@media screen and (max-width: 767px) {
  .title {
    font-size: 1rem;
  }
}
</style>
